import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=37c33bd5&scoped=true&"
import script from "./RegisterUser.vue?vue&type=script&lang=js&"
export * from "./RegisterUser.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&id=37c33bd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c33bd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c33bd5')) {
      api.createRecord('37c33bd5', component.options)
    } else {
      api.reload('37c33bd5', component.options)
    }
    module.hot.accept("./RegisterUser.vue?vue&type=template&id=37c33bd5&scoped=true&", function () {
      api.rerender('37c33bd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/RegisterUser.vue"
export default component.exports